import { Navigate } from "react-router";
import type { AppRouteObject } from "./types";
import { lazyRoute } from "./lazyRoute";
import { withPersonnelRootMetadata } from "./featureRouteMetadata";

export const personnelRoutes = withPersonnelRootMetadata({
    path: "personnel",
    handle: { help: null },
    children: [
        {
            index: true,
            lazy: lazyRoute(() => import("../containers/Personnel/Personnels/PersonnelsPage")),
            handle: { help: { topicKey: "personnels" } }
        },
        {
            path: "create",
            lazy: lazyRoute(() => import("../containers/Personnel/Personnel/PersonnelEditor")),
            handle: { help: { topicKey: "personnel" } }
        },
        {
            path: "byroles",
            lazy: lazyRoute(() => import("../containers/Personnel/PersonnelByRoles/PersonnelByRolesPage")),
            handle: { help: { topicKey: "personnel-by-roles" } }
        },
        {
            path: ":personnelId",
            handle: { help: null },
            children: [
                {
                    index: true,
                    element: <Navigate replace to="details" />,
                    handle: { help: null }
                },
                {
                    path: "details",
                    lazy: lazyRoute(() => import("../containers/Personnel/Personnel/PersonnelEditor")),
                    handle: { help: { topicKey: "personnel" } }
                },
                {
                    path: "trainingcertifications",
                    lazy: lazyRoute(() => import("../containers/Personnel/PersonnelTrainingCertification/PersonnelTrainingCertificationPage")),
                    handle: { help: { topicKey: "personnel-training-certification" } }
                },
                {
                    path: "roles",
                    handle: { help: null },
                    children: [
                        {
                            index: true,
                            lazy: lazyRoute(() => import("../containers/Personnel/PersonnelRoles/PersonnelRolesPage")),
                            handle: { help: { topicKey: "personnel-roles" } }
                        },
                        {
                            path: "create",
                            lazy: lazyRoute(() => import("../containers/Personnel/PersonnelRole/PersonnelRolePage"), { mode: "create" }),
                            handle: { help: { topicKey: "personnel-role" } }
                        },
                        {
                            path: ":personnelRoleId",
                            handle: { help: null },
                            children: [
                                {
                                    index: true,
                                    element: (
                                        <Navigate replace to="details" />
                                    ),
                                    handle: { help: null }
                                },
                                {
                                    path: "details",
                                    lazy: lazyRoute(() => import("../containers/Personnel/PersonnelRole/PersonnelRolePage"), { mode: "edit" }),
                                    handle: { help: { topicKey: "personnel-role" }, breadcrumb: null }
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "permissions",
                    lazy: lazyRoute(() => import("../containers/Personnel/PersonnelPermissions/PersonnelPermissionsPage")),
                    handle: { help: { topicKey: "personnel-permissions" } }
                },
                {
                    path: "activedirectory",
                    lazy: lazyRoute(() => import("../containers/Personnel/PersonnelActiveDirectory/PersonnelActiveDirectoryEditor")),
                    handle: { help: { topicKey: "personnel-active-directory" } }
                },
                {
                    path: "notes",
                    handle: { help: null },
                    children: [
                        {
                            index: true,
                            lazy: lazyRoute(() => import("../containers/Personnel/PersonnelNotes/PersonnelNotesPage")),
                            handle: { help: { topicKey: "personnel-notes" } }
                        },
                        {
                            path: "create",
                            lazy: lazyRoute(() => import("../containers/Notes/Note/NotePageSWR"), { kind: "personnel", mode: "create" }),
                            handle: { help: { topicKey: "note" } }
                        },
                        {
                            path: ":noteId",
                            handle: { help: null },
                            children: [
                                {
                                    index: true,
                                    element: (
                                        <Navigate replace to="details" />
                                    ),
                                    handle: { help: null }
                                },
                                {
                                    path: "details",
                                    lazy: lazyRoute(() => import("../containers/Notes/Note/NotePageSWR"), { kind: "personnel", mode: "edit" }),
                                    handle: { help: { topicKey: "note" } }
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "fellowship",
                    handle: { help: null },
                    children: [
                        {
                            index: true,
                            lazy: lazyRoute(() => import("../containers/Personnel/Fellowship/FellowshipsSWRPage")),
                            handle: { help: { topicKey: "fellowships" } }
                        },
                        {
                            path: "create",
                            lazy: lazyRoute(() => import("../containers/Personnel/Fellowship/FellowshipEditorSWR"), { mode: "create" }),
                            handle: { help: { topicKey: "fellowship" } }
                        },
                        {
                            path: ":fellowshipId",
                            handle: { help: null },
                            children: [
                                {
                                    index: true,
                                    element: (
                                        <Navigate replace to="details" />
                                    ),
                                    handle: { help: null }
                                },
                                {
                                    path: "details",
                                    lazy: lazyRoute(() => import("../containers/Personnel/Fellowship/FellowshipEditorSWR"), { mode: "edit" }),
                                    handle: { help: { topicKey: "fellowship" } }
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
} satisfies AppRouteObject);

